import React,{useState}from'react';
import * as FiIcons from'react-icons/fi';
import SafeIcon from'../common/SafeIcon';

const{FiChevronDown,FiChevronUp,FiGripVertical,FiPlus,FiTrash2}=FiIcons;
const editableTypes=['Single select','Multiple select','Dropdown','Yes / No'];

function QuestionOptionEditor({question,onChange}){
  const[draggedIndex,setDraggedIndex]=useState(null);
  const options=Array.isArray(question.options)?question.options:[];

  const updateOptions=(nextOptions)=>{
    onChange({
      ...question,
      options:nextOptions
    });
  };

  const updateOption=(index,value)=>{
    updateOptions(options.map((option,optionIndex)=>(
      optionIndex===index?value:option
    )));
  };

  const addOption=()=>{
    updateOptions([...options,'New answer option']);
  };

  const removeOption=(index)=>{
    updateOptions(options.filter((_,optionIndex)=>optionIndex!==index));
  };

  const moveOption=(index,direction)=>{
    const target=index+direction;
    if(target<0||target>=options.length)return;

    const next=[...options];
    [next[index],next[target]]=[next[target],next[index]];
    updateOptions(next);
  };

  const dropOption=(targetIndex)=>{
    if(draggedIndex===null||draggedIndex===targetIndex){
      setDraggedIndex(null);
      return;
    }

    const next=[...options];
    const[moved]=next.splice(draggedIndex,1);
    next.splice(targetIndex,0,moved);
    updateOptions(next);
    setDraggedIndex(null);
  };

  if(!editableTypes.includes(question.type))return null;

  const displayedOptions=question.type==='Yes / No'?['Yes','No']:options;

  return <div className="question-option-editor">
    <div className="question-option-heading">
      <div>
        <strong>Answer choices</strong>
        <span>Edit, reorder, or remove the answers clients can choose.</span>
      </div>

      {question.type!=='Yes / No'&&<button
        type="button"
        className="button secondary option-add-button"
        onClick={addOption}
      >
        <SafeIcon icon={FiPlus}/> Add answer
      </button>}
    </div>

    <div className="question-options-list">
      {displayedOptions.length===0?<p className="question-options-empty">
        No answer choices yet. Add the first answer.
      </p>:displayedOptions.map((option,index)=><div
        className={`question-option-row ${draggedIndex===index?'dragging':''}`}
        key={`${question.id}-answer-${index}`}
        draggable={question.type!=='Yes / No'}
        onDragStart={()=>{
          if(question.type!=='Yes / No')setDraggedIndex(index);
        }}
        onDragOver={(event)=>event.preventDefault()}
        onDrop={()=>{
          if(question.type!=='Yes / No')dropOption(index);
        }}
        onDragEnd={()=>setDraggedIndex(null)}
      >
        {question.type!=='Yes / No'&&<span
          className="question-option-handle"
          title="Drag to reorder"
          onMouseDown={(event)=>event.stopPropagation()}
        >
          <SafeIcon icon={FiGripVertical}/>
        </span>}

        <input
          value={option}
          disabled={question.type==='Yes / No'}
          draggable={false}
          onMouseDown={(event)=>event.stopPropagation()}
          onDragStart={(event)=>event.preventDefault()}
          onChange={(event)=>updateOption(index,event.target.value)}
          aria-label={`Answer option ${index+1}`}
        />

        {question.type!=='Yes / No'&&<div className="question-option-actions">
          <button
            type="button"
            className="icon-btn"
            disabled={index===0}
            onClick={()=>moveOption(index,-1)}
            aria-label="Move answer up"
          >
            <SafeIcon icon={FiChevronUp}/>
          </button>

          <button
            type="button"
            className="icon-btn"
            disabled={index===options.length-1}
            onClick={()=>moveOption(index,1)}
            aria-label="Move answer down"
          >
            <SafeIcon icon={FiChevronDown}/>
          </button>

          <button
            type="button"
            className="icon-btn danger"
            onClick={()=>removeOption(index)}
            aria-label={`Delete answer ${index+1}`}
          >
            <SafeIcon icon={FiTrash2}/>
          </button>
        </div>}
      </div>)}
    </div>
  </div>;
}

export default QuestionOptionEditor;